import {
  // eslint-disable-next-line camelcase
  required, email, regex, min_value, max_value, confirmed
} from 'vee-validate/dist/rules'
import { extend, configure } from 'vee-validate'

const config = {
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  },
  bails: true,
  skipOptional: true,
  mode: 'aggressive',
  useConstraintAttrs: true
}

configure(config)

extend('required', {
  ...required,
  message: 'This field is required.'
})

extend('email', {
  ...email,
  message: 'This field must be a valid email.'
})

extend('regex', {
  ...regex,
  message: 'Provided value is not valid.'
})

extend('min', {
  validate(value, { length }) {
    return value.length >= length
  },
  params: ['length'],
  message: 'The field must have at least {length} characters.'
})

extend('min_value', {
  // eslint-disable-next-line camelcase
  ...min_value,
  message: (fieldName, placeholders) => `Provided value is below minimal value - ${placeholders.min}.`
})

extend('max_value', {
  // eslint-disable-next-line camelcase
  ...max_value,
  message: (fieldName, placeholders) => `Provided value is above maximum value - ${placeholders.max}.`
})

extend('confirmed', {
  ...confirmed,
  message: 'Provided values do not match.'
})
